<template>
	<div class="modal-item-locker h-100" dir="ltr" ref="modalItemLocker" @click="dimClicked">
		<vue-draggable-resizable :handles="['br']" :w="position.width" :h="position.height" :x="position.left" :y="position.top" :minw="minSize.width" :minh="minSize.height" :draggable="!positionLast" :resizable="isResizable" :active="modalSizeCss !== 'fullscreen'" :class="{ 'modal-transform-none': !menuStatus ? true : false, 'modal-item': true, [modalSizeCss]: true, 'nm-auto-height': height === 'auto' }" :drag-handle="'.nm-header'" :drag-cancel="'.nm-header .nm-dismiss'" @dragging="onDrag"
			@resizing="onResize" @resizestop="onResizStop" @dragStop="onDragStop" tabscope ref="modalItem">
			<div class="nm-flexitem nm-header">
				<!-- <div class="nm-title-bg"></div> -->
				<div class="nm-dismiss ml-2">
					<a href="#" @click.stop="closeModalInner">
						<icon :icon="['fas', 'times']" />
					</a>
				</div>
				<div v-show="isMaximizable" class="nm-maximize">
					<a href="#" @click="changeFullScreenModalStatus">
						<icon :icon="`fa-solid ${positionLast ? 'fa-compress' : 'fa-expand'}`" />
					</a>
				</div>
				<div class="nm-helpToggler">
					<a href="#" @click="showHelp">
						<icon :title="$t('help')" icon="lightbulb" group="regular" class="help" />
					</a>
				</div>
				<!-- <div class="nm-minimal-btn">
					<a href="#" @click="toggleMinimalModal">
						<icon :icon="`fa-solid fa-arrows-to-line`" />
					</a>
				</div> -->
				<div class="nm-title d-flex align-items-center">
					<div v-if="comIcon" class="nm-title-icon ml-3 d-flex align-items-center justify-content-center" style="font-size: 16px; margin-right: -4px; padding-top: 1px;" :class="comIconClasses">
						<icon :icon="comIcon" />
					</div>
					<span class="nm-title-body">{{ page.title }}</span>
				</div>
			</div>
			<div v-if="localButtons.length > 0" class="nm-flexitem nm-toolbar" tabscope tabindex="1">
				<div class="nm-buttons-container d-flex">
					<div v-for="(b, i) in localButtons" :key="b.id" tabscope tabindex="1" class="h-100">
						<nk-print-button v-if="b.type == 'print'" :tabindex="i + 1" :options="b" @click="buttonClicked" @optionsChanged="buttonOptionsChanged"></nk-print-button>

						<nk-excel-button v-else-if="b.type == 'excel'" :tabindex="i + 1" :options="b" @click="buttonClicked" @optionsChanged="buttonOptionsChanged"></nk-excel-button>

						<div v-else-if="b.type == 'seprator' && b.visible !== false" class="seprator mx-2"></div>

						<nk-button v-else-if="!b.items" :tabindex="i + 1" :options="b" @click="buttonClicked" @optionsChanged="buttonOptionsChanged"></nk-button>

						<nk-drop-button v-else-if="b.items" :tabindex="i + 1" :options="b" @click="buttonClicked" @optionsChanged="buttonOptionsChanged"></nk-drop-button>

					</div>
				</div>
			</div>
			<div class="nm-flexitem nm-body" tabindex="0">
				<component @click="comClicked" v-if="page.component" ref="component" :is="page.component" :data="page.data" :options="page.options" @buttons-changed="buttonsChanged" @title-changed="titleChanged" @icon-changed="iconChanged" @icon-classes-changed="iconClassesChanged" @resolve="resolved" @reject="rejected" @customRejectMsg="setCustomRejectMsg">
				</component>
			</div>
		</vue-draggable-resizable>
	</div>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import { mapActions, mapGetters } from 'vuex'
	import TabOrder from '~/statics/taborder-functions'
	import emptyId from '~/statics/empty-id'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import $sc from '~/plugins/shortcut.collection.js'
	import { i18nInstance } from '~/plugins/localization'

	const SIZES = {
		SM: { width: 350, height: 350, top: null, left: null },
		MD: { width: 800, height: 500, top: null, left: null },
		LG: { width: 1000, height: 750, top: null, left: null },
		FULLSCREEN: { width: 10, height: 10 },
	}

	export default {
		props: {
			page: { required: true },
			options: { type: Object },
		},
		emits: ['buttonsChanged', 'showHelp'],
		data() {
			return {
				position: {
					top: null,
					left: null,
					width: null,
					height: null,
				},
				positionLast: null,
				currentState: null,
				customRejectMsg: null
			}
		},
		computed: {
			...mapGetters({
				getActiveState: 'appStates/getActiveByKey',
				menuStatus: 'menuStatus'

			}),

			localButtons() {
				if (!this.page || !this.page.buttons || this.page.buttons.length === 0) {
					return []
				}

				return this.page.buttons.filter(x => x.visible !== false && x.type !== 'seprator').map(b => ({
					...b,
					hideTitle: b.hideTitle !== undefined ? b.hideTitle : true,
					hideTooltip: b.hideTooltip !== undefined ? b.hideTooltip : false,
					tooltipEnabled: false,
					hideShortcut: true
				}))
			},

			size() {
				return (_.get(this.page, 'component.modal.size') || 'fullscreen').toUpperCase()
			},
			isResizable() {
				const resizable = _.get(this.page, 'component.modal.resizable')
				return !this.positionLast && resizable !== false
			},
			isMaximizable() {
				const maximizable = _.get(this.page, 'component.modal.maximizable')
				return this.size !== 'FULLSCREEN' && maximizable !== false
			},
			width() {
				if (this.size === 'CUSTOM')
					return _.get(this.page, 'component.modal.width') || null
				else if (this.size === 'FULLSCREEN')
					return $('.nm-dim-inner').first().width()
				else return SIZES[this.size].width

			},
			height() {
				if (this.size === 'CUSTOM')
					return _.get(this.page, 'component.modal.height') || null
				else if (this.size === 'FULLSCREEN')
					return $('.nm-dim-inner').first().height()
				else return SIZES[this.size].height


			},
			comStateUID() {
				return _.get(this.page, 'component.modal.stateUID') || ''
			},
			comStateTitle() {
				return this.page.title || i18nInstance.global.t('unknown')
			},
			comIcon() {
				return this.page.icon || _.get(this.page, 'component.modal.icon') || null
			},
			comIconClasses() {
				return this.page.iconClasses || _.get(this.page, 'component.modal.iconClasses') || ''
			},
			modalSizeCss() {
				switch (this.size) {
					case 'MD':
					case 'SM':
					case 'LG':
					case 'CUSTOM':
						return ''
					case 'FULLSCREEN':
						return 'fullscreen'
					default:
						return 'fullscreen'
				}
			},
			stateUID() {
				return 'modal_' + this.comStateUID.split('@')[0]
			},
			stateEnabled() {
				return this.comStateUID != null && this.comStateUID !== ''
			},
			minSize() {
				return SIZES.SM
			},
			isMinimalActive() {
				let state = this.getActiveState(`minimalModal_${this.comStateUID.split('@')[0]}`)
				return !!state?.value
			}
		},
		created() {
			this.settings = _.extend({}, this.settings, this.options)
			this.savePosition = _.debounce(this.savePosition, 500)
			this.syncStates = _.debounce(this.syncStates, 3000)
		},
		mounted() {
			this.focusStartup()
			this.preparePosition()
			this.defer(() => {
				$(this.$refs.modalItemLocker).addClass('show')
			}, 1)
		},
		methods: {
			...mapActions({
				menu_show: 'hide_show',
				modifyStates: 'appStates/modify',
				syncStates: 'appStates/sync',
				refreshStates: 'appStates/refresh',
			}),
			showHelp() {
				this.$emit('showHelp')
			},
			comClicked(e) {
				if (!$(e.target).closest('button.btn.menu-btn').length && !$(e.target).closest('button.border-0.bg-transparent.menu-btn.p-1').length)
					e.stopPropagation()
			},
			focusStartup() {
				this.defer(() => {
					const el = $(this.$el).find('.nm-body')
					if (el.length > 0) {
						el.focus()

						const startupEl = el.find('[startup]')
						if (startupEl.length > 0) {
							startupEl[0].focus()
						}
					}
				}, 50)
			},
			closeModalInner($event) {
				$event.preventDefault()

				const comp = this.$refs.component
				const isDataChanged = comp.isDataChanged
				const checkDataChange = this.page?.component?.modal?.checkDataChange
				const onClose = () => {
					this.rejected(this.customRejectMsg)
					this.close()
				}

				if (checkDataChange && isDataChanged && typeof isDataChanged === 'function')
					isDataChanged()
						.then(isDataChanged => {
							if (isDataChanged)
								dialog({
									title: this.$t('notifications.titles-warning'),
									body: this.$t('modal.data-changed'),
									type: 'warning',
									buttons: [
										{
											title: this.$t('dialog.yes'),
											shortcut: $sc.find('yes', 'dialog'),
											isPrimary: true,
											handle: (button, page, e) => {
												onClose()
											},
										},
										{
											title: this.$t('dialog.no'),
											shortcut: $sc.find('no', 'dialog'),
											isCancel: true,
											handle: (button, page, e) => {
											},
										},
									],
								})
							else
								onClose()
						})
				else
					onClose()
			},
			changeFullScreenModalStatus() {
				if (this.positionLast) {
					this.onResize(this.positionLast.left, this.positionLast.top, this.positionLast.width, this.positionLast.height)
					this.positionLast = null
				} else {
					let windowHeight = window.innerHeight
					let windowWidth = window.innerWidth
					this.positionLast = { ...this.position }
					this.onResize(0, 0, windowWidth, windowHeight)
				}

			},
			buttonClicked(button, e) {

				if (e)
					e.preventDefault()

				var handle = button.handle
				if (handle != null) {
					handle(button, this.page, e)
				}
			},
			buttonOptionsChanged(button) {
				if (!this.page || !this.page.buttons) {
					return
				}

				const index = this.page.buttons.findIndex((x) => x.id === button.id)
				if (index > -1) {
					_.extend(this.page.buttons[index], button)
					this.$emit('buttonsChanged', this.id, this.page.buttons)
				}
			},
			buttonsChanged(buts) {
				this.page.buttons = buts
			},
			titleChanged(title) {
				this.page.title = title
			},
			iconChanged(icon) {
				this.page.icon = icon
			},
			iconClassesChanged(classes) {
				this.page.iconClasses = classes
			},
			resolved(response) {
				this.page.resolve(response)
			},
			rejected(error) {
				this.page.reject(error)
			},

			dimClicked(e) {
				var $target = $(e.target)
				if (
					!$target.hasClass('modal-item') &&
					!($target.parents('.modal-item').length > 0) &&
					!$(this.$refs.modalItemLocker).hasClass('shake')
				) {
					$(this.$refs.modalItemLocker).addClass('shake')
					this.focusStartup()
					this.defer(this.stopShaking, 1000)
				}
			},
			stopShaking() {
				$(this.$refs.modalItemLocker).removeClass('shake')
			},
			onResize(x, y, width, height) {
				this.position.left = x
				this.position.top = y
				this.position.width = width
				this.position.height = height
			},
			onDrag(x, y) {
				this.position.left = x
				this.position.top = y
			},
			onResizStop() {
				this.savePosition()
			},
			onDragStop() {
				let windowHeight = window.innerHeight
				let windowWidth = window.innerWidth

				if (this.position.left <= -700) {
					this.position.left = -700
				} else if (this.position.left >= windowWidth - 200) {
					this.position.left = windowWidth - 200
				} else if (this.position.top <= 2) {
					this.position.top = 2
				} else if (this.position.top >= windowHeight - 100) {
					this.position.top = windowHeight - 100
				}
				this.savePosition()
			},
			preparePosition() {
				if (this.stateEnabled) {
					this.currentState = this.getActiveState(this.stateUID)
					if (this.currentState && this.currentState.value) {
						this.position = _.extend({}, this.position, this.currentState.value)
						return
					}
				}
				let windowWidth = $('.nm-dim-inner').first().width()
				let windowHeight = $('.nm-dim-inner').first().height()
				let safeHeight = this.height === 'auto' ? 400 : this.height
				let top = Math.round((windowHeight - safeHeight) / 2)
				let left = Math.round((windowWidth - this.width) / 2)
				left = Math.max(left, 0) // in mobile view modal will be pushed out of the screen
				top = Math.max(top, 0)
				let tmp = {
					top: top,
					left: left,
					height: this.height,
					width: this.width,
				}
				if ($(".nm-dim-inner").eq(-2).length > 0) { // if there is more than 1 modal in the page
					tmp.top += 15
					tmp.left += 15
				}
				this.position = _.extend(this.position, tmp)
			},
			savePosition() {
				if (!this.stateEnabled) {
					return
				}
				if (this.currentState == null) {
					this.currentState = {
						id: emptyId,
						key: this.stateUID,
						name: this.comStateTitle,
						isActive: true,
						rowState: 'new',
					}
				} else {
					this.currentState.rowState = 'changed'
				}

				this.currentState.value = this.position

				this.modifyStates([this.currentState])
				return this.syncStates()
			},
			setCustomRejectMsg(msg) {
				this.customRejectMsg = msg
			},
			toggleMinimalModal() {
				let state = this.getActiveState(`minimalModal_${this.comStateUID.split('@')[0]}`)

				if (!state) {
					state = {
						id: emptyId,
						key: `minimalModal_${this.comStateUID.split('@')[0]}`,
						name: `minimalModal_${this.comStateUID.split('@')[0]}`,
						isActive: true,
						rowState: 'new',
						value: true
					}
				} else {
					state.value = !state.value
					state.rowState = 'changed'
				}

				this.modifyStates([state])
				this.syncStates()
			},
			subscribeKeys() {
				// move handlers to the begining of the handlers
				this.$keyHandler.ReserveAt('modal-taborder-ctrl-enter-tabscope', 0)
				this.$keyHandler.ReserveAt('modal-taborder-previous', 0)
				this.$keyHandler.ReserveAt('modal-taborder-next', 0)

				this.$keyHandler.Subscribe({
					name: 'modal-close',
					keyCode: 27, // 27:escape
					el: this.$el,
					context: this,
					autoRemove: false,
					handler: function (sender, e) {
						this.closeModalInner(e)
						this.menu_show(true)
					},
				})

				// this.$keyHandler.Subscribe({
				// 	name: 'modal-button-click',
				// 	el: this.$el,
				// 	ctrlKey: undefined,
				// 	altKey: undefined,
				// 	shiftKey: undefined,
				// 	context: this,
				// 	handler: function (sender, e) {
				// 		let button = _.head(
				// 			this.page.buttons.filter((b) => {
				// 				return (
				// 					b.visible === true &&
				// 					b.userHasAccess === true &&
				// 					b.shortcut.keyCode === e.keyCode &&
				// 					(b.shortcut.ctrlKey == null ||
				// 						b.shortcut.ctrlKey === e.ctrlKey) &&
				// 					(b.shortcut.shiftKey == null ||
				// 						b.shortcut.shiftKey === e.shiftKey) &&
				// 					(b.shortcut.altKey == null || b.shortcut.altKey === e.altKey)
				// 				)
				// 			})
				// 		)
				// 		console.log(button)
				// 		if (button) {
				// 			e.preventDefault()
				// 			this.buttonClicked(button, e)
				// 			return true
				// 		}
				// 	},
				// })

				TabOrder.subscribeKeys('modal', this)
			},
		},
	}
</script>
<style src="~/styles/nikan-modal.less" lang="less"></style>
<style>
	.modal-item.nm-auto-height {
		height: auto !important;
		min-height: max-content !important;
	}
</style>
